<ham-modal
    [title]="'aumico_proffix_connect_modal_title' | i18next"
    [hideFooter]="true"
    [size]="'sm'"
    [hideCloseIcon]="step === 'testing'"
    [enableKeyboardShortcuts]="step !== 'testing'"
    (cancel)="onCancel()"
>
    <div class="proffix-modal-body">
        <!-- Step 1: form -->
        <section *ngIf="step === 'welcome'">
            <p class="proffix-modal-body__paragraph">
                {{ 'aumico_proffix_step_welcome_intro' | i18next }}
            </p>

            <div class="proffix-modal-body__field">
                <label for="proffixDisplayName">
                    {{ 'aumico_integration_setup_displayname_label' | i18next }}
                </label>
                <input
                    hamInput
                    id="proffixDisplayName"
                    type="text"
                    [(ngModel)]="displayName"
                    [placeholder]="'aumico_integration_setup_displayname_placeholder' | i18next"
                />
                <small class="proffix-modal-body__hint">
                    {{ 'aumico_proffix_step_config_displayname_help' | i18next }}
                </small>
            </div>

            <div class="proffix-modal-body__field">
                <label for="proffixServerUrl">
                    {{ 'aumico_proffix_step_config_serverurl_label' | i18next }}
                </label>
                <input
                    hamInput
                    id="proffixServerUrl"
                    type="url"
                    [(ngModel)]="serverUrl"
                    placeholder="https://proffix.example.ch:11011/pxapi/V4"
                />
                <small class="proffix-modal-body__hint">
                    {{ 'aumico_proffix_step_config_serverurl_help' | i18next }}
                </small>
                <small *ngIf="serverUrlInvalid" class="proffix-modal-body__invalid" role="alert">
                    {{ 'aumico_proffix_validation_serverurl_invalid' | i18next }}
                </small>
            </div>

            <!--
                Both secrets are real `type=password` inputs (toggle flips to `text`).
                `autocomplete="new-password"` keeps browsers from autofilling a stored
                login into them.
            -->
            <div class="proffix-modal-body__field">
                <label for="proffixRestApiKey">
                    {{ 'aumico_proffix_step_config_restapikey_label' | i18next }}
                </label>
                <input
                    hamInput
                    id="proffixRestApiKey"
                    [type]="showRestApiKey ? 'text' : 'password'"
                    [(ngModel)]="restApiKey"
                    autocomplete="new-password"
                    spellcheck="false"
                    data-lpignore="true"
                />
                <div class="proffix-modal-body__hint-row">
                    <small class="proffix-modal-body__hint">
                        {{ 'aumico_proffix_step_config_restapikey_help' | i18next }}
                    </small>
                    <button
                        type="button"
                        class="proffix-modal-body__toggle"
                        (click)="onToggleRestApiKey()"
                    >
                        {{
                            showRestApiKey
                                ? ('aumico_proffix_step_config_password_hide' | i18next)
                                : ('aumico_proffix_step_config_password_show' | i18next)
                        }}
                    </button>
                </div>
            </div>

            <div class="proffix-modal-body__field">
                <label for="proffixUsername">
                    {{ 'aumico_proffix_step_config_username_label' | i18next }}
                </label>
                <input
                    hamInput
                    id="proffixUsername"
                    type="text"
                    [(ngModel)]="username"
                    autocomplete="off"
                />
            </div>

            <div class="proffix-modal-body__field">
                <label for="proffixPassword">
                    {{ 'aumico_proffix_step_config_password_label' | i18next }}
                </label>
                <input
                    hamInput
                    id="proffixPassword"
                    [type]="showPassword ? 'text' : 'password'"
                    [(ngModel)]="password"
                    autocomplete="new-password"
                    spellcheck="false"
                    data-lpignore="true"
                />
                <div class="proffix-modal-body__hint-row">
                    <small class="proffix-modal-body__hint">
                        {{ 'aumico_proffix_step_config_password_help' | i18next }}
                    </small>
                    <button
                        type="button"
                        class="proffix-modal-body__toggle"
                        (click)="onTogglePassword()"
                    >
                        {{
                            showPassword
                                ? ('aumico_proffix_step_config_password_hide' | i18next)
                                : ('aumico_proffix_step_config_password_show' | i18next)
                        }}
                    </button>
                </div>
            </div>

            <!-- A disabled Connect says why (guidelines §2.1): the required fields still empty. -->
            <p *ngIf="missingFieldLabelKeys.length > 0" class="proffix-modal-body__missing">
                {{ 'aumico_proffix_validation_missing_fields' | i18next }}
                <ng-container *ngFor="let labelKey of missingFieldLabelKeys; let last = last">
                    {{ labelKey | i18next }}{{ last ? '' : ',' }}
                </ng-container>
            </p>

            <div class="proffix-modal-body__actions">
                <ham-button
                    variant="primary"
                    size="sm"
                    [disabled]="!isFormValid"
                    (buttonClick)="onSubmit()"
                >
                    {{ 'aumico_integration_connect_button' | i18next }}
                </ham-button>
                <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onCancel()">
                    {{ 'aumico_button_cancel' | i18next }}
                </ham-button>
            </div>
        </section>

        <!--
            Step 2: BE testing the credentials. No way out here (no Cancel, close icon or Escape):
            the BE stores the connection anyway, and only an open flow auto-matches its Mandanten.
            The step ends with the BE's answer (success closes, failure shows the error step).
        -->
        <section *ngIf="step === 'testing'" class="proffix-modal-body__loading">
            <div class="proffix-modal-body__spinner"></div>
            <p class="proffix-modal-body__paragraph">
                {{ 'aumico_integration_status_testing' | i18next }}
            </p>
        </section>

        <!-- Step 3: error from the credential test -->
        <section *ngIf="step === 'error'" class="proffix-modal-body__error">
            <lucide-icon
                name="triangle-alert"
                [size]="48"
                aria-hidden="true"
                class="proffix-modal-body__error-glyph"
            ></lucide-icon>
            <h3 class="proffix-modal-body__title">{{ 'aumico_integration_status_error_title' | i18next }}</h3>
            <p class="proffix-modal-body__error-message">{{ errorMessage }}</p>
            <div class="proffix-modal-body__actions">
                <ham-button variant="primary" size="sm" (buttonClick)="onRetryFromError()">
                    {{ 'aumico_button_retry' | i18next }}
                </ham-button>
                <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onCancel()">
                    {{ 'aumico_button_cancel' | i18next }}
                </ham-button>
            </div>
        </section>
    </div>
</ham-modal>
